import actionTypes from 'src/modules/redux/actionTypes'

export const setSavedFiltersLoading = (isLoading) => ({
  type: actionTypes.SET_SAVED_FILTERS_LOADING,
  payload: {isLoading}
})